import { Container, Heading, Text } from "@chakra-ui/react";
import Head from "next/head";

const PrivacyPolicy = () => {
  return (
    <Container maxW="container.xl">
      <Head>
        <link rel="canonical" href={`https://welldoing.org/privacy-policy`} />
      </Head>
      <Heading m="24px">Privacy policy</Heading>
      <Text>
        This privacy policy applies between you, the User of this Website and
        Welldoing Limited, the owner and provider of this Website. Welldoing
        Limited takes the privacy of your information very seriously. This
        privacy policy applies to our use of any and all Data collected by us or
        provided by you in relation to your use of the Website. This privacy
        policy should be read alongside, and in addition to, our Terms and
        Conditions, which can be found at:
        https://welldoing.org/terms-and-conditions. Please read this privacy
        policy carefully.
      </Text>
      <Heading m="24px">Definitions and interpretation </Heading>
      <Text paddingLeft="24px">
        <ol>
          <li>
            In this privacy policy, the following definitions are used: Data
            collectively all information that you submit to Welldoing Limited
            via the Website. This definition incorporates, where applicable, the
            definitions provided in the Data Protection Laws; Cookies a small
            text file placed on your computer by this Website when you visit
            certain parts of the Website and/or when you use certain features of
            the Website. Details of the cookies used by this Website are set out
            in the clause below (Cookies); Data Protection Laws any applicable
            law relating to the processing of personal Data, including but not
            limited to the Directive 96/46/EC (Data Protection Directive) or the
            GDPR, and any national implementing laws, regulations and secondary
            legislation, for as long as the GDPR is effective in the UK; GDPR
            the General Data Protection Regulation (EU) 2016/679; Welldoing
            Limited, or us Welldoing Limited, a company incorporated in England
            and Wales with registered number 08614689 whose registered office is
            at Canterbury House, 1 Royal Street, London, SE1 7LL; UK and EU
            Cookie Law the Privacy and Electronic Communications (EC Directive)
            Regulations 2003 as amended by the Privacy and Electronic
            Communications (EC Directive) (Amendment) Regulations 2011; User or
            you any third party that accesses the Website and is not either (i)
            employed by Welldoing Limited and acting in the course of their
            employment or (ii) engaged as a consultant or otherwise providing
            services to Welldoing Limited and accessing the Website in
            connection with the provision of such services; and Website the
            website that you are currently using, https://welldoing.org/, and
            any sub-domains of this site unless expressly excluded by their own
            terms and conditions.
          </li>
          <li style={{ paddingTop: "16px" }}>
            In this privacy policy, unless the context requires a different
            interpretation:
            <ol type="a" style={{ paddingTop: "16px", paddingLeft: "24px" }}>
              <li>the singular includes the plural and vice versa;</li>
              <li>
                references to sub-clauses, clauses, schedules or appendices are
                to sub-clauses, clauses, schedules or appendices of this privacy
                policy;
              </li>
              <li>
                a reference to a person includes firms, companies, government
                entities, trusts and partnerships;
              </li>
              <li>
                &quot;including&quot; is understood to mean including without
                limitation&quot;;
              </li>
              <li>
                reference to any statutory provision includes any modification
                or amendment of it;
              </li>
              <li>
                the headings and sub-headings do not form part of this privacy
                policy.
              </li>
            </ol>
          </li>
        </ol>
      </Text>
      <Heading m="24px">Scope of this privacy policy</Heading>
      <Text paddingLeft="24px">
        <ol start="3">
          <li>
            This privacy policy applies only to the actions of Welldoing Limited
            and Users with respect to this Website. It does not extend to any
            websites that can be accessed from this Website including, but not
            limited to, any links we may provide to social media websites.
          </li>
          <li>
            For purposes of the applicable Data Protection Laws, Welldoing
            Limited is the &quot;data controller&quot;. This means that
            Welldoing Limited determines the purposes for which, and the manner
            in which, your Data is processed.
          </li>
        </ol>
      </Text>
      <Heading m="24px">Data collected</Heading>
      <Text paddingLeft="24px">
        <ol start="5">
          <li>
            We may collect the following Data, which includes personal Data,
            from you:
            <ol type="a" style={{ paddingTop: "16px", paddingLeft: "24px" }}>
              <li>name;</li>
              <li>date of birth;</li>
              <li>gender;</li>
              <li>profession;</li>
              <li>
                contact Information such as email addresses and telephone
                numbers;
              </li>
              <li>
                demographic information such as postcode, preferences and
                interests;{" "}
              </li>
              <li>brief description of issue; </li>
              <li>in each case, in accordance with this privacy policy.</li>
            </ol>
          </li>
        </ol>
      </Text>
      <Heading m="24px">How we collect Data</Heading>
      <Text paddingLeft="24px">
        <ol start="6">
          <li>
            We collect Data in the following ways:
            <ol type="a" style={{ paddingTop: "16px", paddingLeft: "24px" }}>
              <li>data is given to us by you; and</li>
              <li>data is collected automatically.</li>
            </ol>
          </li>
        </ol>
      </Text>
      <Heading m="24px">Data that is given to us by you</Heading>
      <Text paddingLeft="24px">
        <ol start="7">
          <li>
            Welldoing Limited will collect your Data in a number of ways, for
            example:
            <ol type="a" style={{ paddingTop: "16px", paddingLeft: "24px" }}>
              <li>
                when you contact us through the Website, by telephone, post,
                e-mail or through any other means;
              </li>
              <li>
                when you register with us and set up an account to receive our
                products/services;
              </li>
              <li>
                when you complete surveys that we use for research purposes
                (although you are not obliged to respond to them);
              </li>
              <li>
                when you make payments to us, through this Website or otherwise;
              </li>
              <li>
                when you elect to receive marketing communications from us;
              </li>
              <li>
                when you use our services; in each case, in accordance with this
                privacy policy.
              </li>
            </ol>
          </li>
        </ol>
      </Text>
      <Heading m="24px">Data that is collected automatically</Heading>
      <Text paddingLeft="24px">
        <ol start="8">
          <li>
            To the extent that you access the Website, we will collect your Data
            automatically, for example:
            <ol type="a" style={{ paddingTop: "16px", paddingLeft: "24px" }}>
              <li>
                we automatically collect some information about your visit to
                the Website. This information helps us to make improvements to
                Website content and navigation, and includes your IP address,
                the date, times and frequency with which you access the Website
                and the way you use and interact with its content.
              </li>
              <li>
                we will collect your Data automatically via cookies, in line
                with the cookie settings on your browser. For more information
                about cookies, and how we use them on the Website, see the
                section below, headed &quot;Cookies&quot;.
              </li>
            </ol>
          </li>
        </ol>
      </Text>
      <Heading m="24px">Our use of Data</Heading>
      <Text paddingLeft="24px">
        <ol start="9">
          <li>
            Any or all of the above Data may be required by us from time to time
            in order to provide you with the best possible service and
            experience when using our Website. Specifically, Data may be used by
            us for the following reasons:
            <ol type="a" style={{ paddingTop: "16px", paddingLeft: "24px" }}>
              <li>internal record keeping;</li>
              <li>improvement of our products / services;</li>
              <li>to facilitate the therapy matching process;</li>
            </ol>
            in each case, in accordance with this privacy policy.
          </li>
          <li>
            We may use your Data for the above purposes if we deem it necessary
            to do so for our legitimate interests. If you are not satisfied with
            this, you have the right to object in certain circumstances (see the
            section headed &quot;Your rights&quot; below).
          </li>
          <li>
            When you register with us and set up an account to receive our
            services, the legal basis for this processing is the performance of
            a contract between you and us and/or taking steps, at your request,
            to enter into such a contract.
          </li>
        </ol>
      </Text>
      <Heading m="24px">Who we share Data with</Heading>
      <Text paddingLeft="24px">
        <ol start="12">
          <li>
            We may share your Data with the following groups of people for the
            following reasons:
            <ol type="a" style={{ paddingTop: "16px", paddingLeft: "24px" }}>
              <li>
                our employees, agents and/or professional advisors - to
                facilitate the matching to a therapist and/or the booking of a
                session;
              </li>
              <li>
                third party payment providers who process payments made over the
                Website - to enable third party payment providers to process
                user payments and refunds;
              </li>
              <li>
                therapists - so that therapists can respond to contact requests.
              </li>
            </ol>
            in each case, in accordance with this privacy policy.
          </li>
        </ol>
      </Text>
      <Heading m="24px">Keeping Data secure</Heading>
      <Text paddingLeft="24px">
        <ol start="13">
          <li>
            We will use technical and organisational measures to safeguard your
            Data, for example: a. access to your account is controlled by a
            password and a user name that is unique to you. b. we store your
            Data on secure servers.
          </li>
          <li>
            We are certified to ISO 27001. This family of standards helps us
            manage your Data and keep it secure.
          </li>
          <li>
            Technical and organisational measures include measures to deal with
            any suspected data breach. If you suspect any misuse or loss or
            unauthorised access to your Data, please let us know immediately by
            contacting us via this e-mail address: info@welldoing.org.
          </li>
          <li>
            If you want detailed information from Get Safe Online on how to
            protect your information and your computers and devices against
            fraud, identity theft, viruses and many other online problems,
            please visit www.getsafeonline.org. Get Safe Online is supported by
            HM Government and leading businesses.
          </li>
        </ol>
      </Text>
      <Heading m="24px">Data retention</Heading>
      <Text paddingLeft="24px">
        <ol start="17">
          <li>
            Unless a longer retention period is required or permitted by law, we
            will only hold your Data on our systems for the period necessary to
            fulfil the purposes outlined in this privacy policy or until you
            request that the Data be deleted.
          </li>
          <li>
            Even if we delete your Data, it may persist on backup or archival
            media for legal, tax or regulatory purposes.
          </li>
        </ol>
      </Text>
      <Heading m="24px">Your rights</Heading>
      <Text paddingLeft="24px">
        <ol start="19">
          <li>
            You have the following rights in relation to your Data:
            <ol type="a" style={{ paddingTop: "16px", paddingLeft: "24px" }}>
              <li>
                Right to access - the right to request (i) copies of the
                information we hold about you at any time, or (ii) that we
                modify, update or delete such information. If we provide you
                with access to the information we hold about you, we will not
                charge you for this, unless your request is &quot;manifestly
                unfounded or excessive.&quot; Where we are legally permitted to
                do so, we may refuse your request. If we refuse your request, we
                will tell you the reasons why.
              </li>
              <li>
                Right to correct - the right to have your Data rectified if it
                is inaccurate or incomplete.
              </li>
              <li>
                Right to erase - the right to request that we delete or remove
                your Data from our systems.
              </li>
              <li>
                Right to restrict our use of your Data - the right to
                &quot;block&quot; us from using your Data or limit the way in
                which we can use it.{" "}
              </li>
              <li>
                Right to data portability - the right to request that we move,
                copy or transfer your Data.{" "}
              </li>
              <li>
                Right to object - the right to object to our use of your Data
                including where we use it for our legitimate interests.{" "}
              </li>
            </ol>
          </li>
          <li>
            To make enquiries, exercise any of your rights set out above, or
            withdraw your consent to the processing of your Data (where consent
            is our legal basis for processing your Data), please contact us via
            this e-mail address: info@welldoing.org.
          </li>
          <li>
            If you are not satisfied with the way a complaint you make in
            relation to your Data is handled by us, you may be able to refer
            your complaint to the relevant data protection authority. For the
            UK, this is the Information Commissioner&apos;s Office (ICO). The
            ICO&apos;s contact details can be found on their website at
            https://ico.org.uk/.{" "}
          </li>
          <li>
            It is important that the Data we hold about you is accurate and
            current. Please keep us informed if your Data changes during the
            period for which we hold it.
          </li>
        </ol>
      </Text>
      <Heading m="24px">Links to other websites</Heading>
      <Text paddingLeft="24px">
        <ol start="23">
          <li>
            This Website may, from time to time, provide links to other
            websites. We have no control over such websites and are not
            responsible for the content of these websites. This privacy policy
            does not extend to your use of such websites. You are advised to
            read the privacy policy or statement of other websites prior to
            using them.
          </li>
        </ol>
      </Text>
      <Heading m="24px">Changes of business ownership and control</Heading>
      <Text paddingLeft="24px">
        <ol start="24">
          <li>
            Welldoing Limited may, from time to time, expand or reduce our
            business and this may involve the sale and/or the transfer of
            control of all or part of Welldoing Limited. Data provided by Users
            will, where it is relevant to any part of our business so
            transferred, be transferred along with that part and the new owner
            or newly controlling party will, under the terms of this privacy
            policy, be permitted to use the Data for the purposes for which it
            was originally supplied to us.{" "}
          </li>
          <li>
            We may also disclose Data to a prospective purchaser of our business
            or any part of it.
          </li>
          <li>
            In the above instances, we will take steps with the aim of ensuring
            your privacy is protected.
          </li>
        </ol>
      </Text>
      <Heading m="24px">Cookies</Heading>
      <Text paddingLeft="24px">
        <ol start="27">
          <li>
            This Website may place and access certain Cookies on your computer.
            Welldoing Limited uses Cookies to improve your experience of using
            the Website and to improve our range of products and services.
            Welldoing Limited has carefully chosen these Cookies and has taken
            steps to ensure that your privacy is protected and respected at all
            times.
          </li>
          <li>
            All Cookies used by this Website are used in accordance with current
            UK and EU Cookie Law.
          </li>
          <li>
            Before the Website places Cookies on your computer, you will be
            presented with a message bar requesting your consent to set those
            Cookies. By giving your consent to the placing of Cookies, you are
            enabling Welldoing Limited to provide a better experience and
            service to you. You may, if you wish, deny consent to the placing of
            Cookies; however certain features of the Website may not function
            fully or as intended.
          </li>
          <li>
            This Website may place the following Cookies: Type of Cookie Purpose
            Strictly necessary cookies These are cookies that are required for
            the operation of our website. They include, for example, cookies
            that enable you to log into secure areas of our website, use a
            shopping cart or make use of e-billing services.
            Analytical/performance cookies They allow us to recognise and count
            the number of visitors and to see how visitors move around our
            website when they are using it. This helps us to improve the way our
            website works, for example, by ensuring that users are finding what
            they are looking for easily.
          </li>
          <li>
            You can find a list of Cookies that we use in the Cookies Schedule.
          </li>
          <li>
            You can choose to enable or disable Cookies in your internet
            browser. By default, most internet browsers accept Cookies but this
            can be changed. For further details, please consult the help menu in
            your internet browser.
          </li>
          <li>
            You can choose to delete Cookies at any time; however you may lose
            any information that enables you to access the Website more quickly
            and efficiently including, but not limited to, personalisation
            settings.
          </li>
          <li>
            It is recommended that you ensure that your internet browser is
            up-to-date and that you consult the help and guidance provided by
            the developer of your internet browser if you are unsure about
            adjusting your privacy settings.
          </li>
          <li>
            For more information generally on cookies, including how to disable
            them, please refer to aboutcookies.org. You will also find details
            on how to delete cookies from your computer.
          </li>
        </ol>
      </Text>

      <Heading m="24px">General</Heading>
      <Text paddingLeft="24px">
        <ol start="36">
          <li>
            You may not transfer any of your rights under this privacy policy to
            any other person. We may transfer our rights under this privacy
            policy where we reasonably believe your rights will not be affected.
          </li>
          <li>
            If any court or competent authority finds that any provision of this
            privacy policy (or part of any provision) is invalid, illegal or
            unenforceable, that provision or part-provision will, to the extent
            required, be deemed to be deleted, and the validity and
            enforceability of the other provisions of this privacy policy will
            not be affected.{" "}
          </li>
          <li>
            Unless otherwise agreed, no delay, act or omission by a party in
            exercising any right or remedy will be deemed a waiver of that, or
            any other, right or remedy.{" "}
          </li>
          <li>
            This Agreement will be governed by and interpreted according to the
            law of England and Wales. All disputes arising under the Agreement
            will be subject to the exclusive jurisdiction of the English and
            Welsh courts.
          </li>
        </ol>
      </Text>

      <Heading m="24px">Changes to this privacy policy</Heading>
      <Text paddingLeft="24px">
        <ol start="40">
          <li>
            Welldoing Limited reserves the right to change this privacy policy
            as we may deem necessary from time to time or as may be required by
            law. Any changes will be immediately posted on the Website and you
            are deemed to have accepted the terms of the privacy policy on your
            first use of the Website following the alterations. You may contact
            Welldoing Limited by email at info@welldoing.org.
          </li>
        </ol>
      </Text>

      <Heading m="24px">Attribution</Heading>
      <Text paddingLeft="24px">
        <ol start="41">
          <li>
            This privacy policy was created using a document from Rocket Lawyer
            (https://www.rocketlawyer.co.uk).
          </li>
        </ol>
      </Text>

      <Heading m="24px">Cookies</Heading>
      <Text paddingLeft="24px">
        Below is a list of the cookies that we use. We have tried to ensure this
        is complete and up to date, but if you think that we have missed a
        cookie or there is any discrepancy, please let us know. <br></br>
        <br></br>
        Strictly necessary <br></br>
        <br></br>We use the following strictly necessary cookies:
        <table>
          <tbody>
            <tr>
              <td>Description of Cookie</td>
              <td>Purpose</td>
            </tr>

            <tr>
              <td>Session Cookie</td>
              <td>
                We use this session cookie to remember you and maintain your
                session whilst you are using our website
              </td>
            </tr>
          </tbody>
        </table>
        <br></br>
        <br></br>
        Analytical/performance
        <br></br>
        <br></br>
        We use the following analytical/performance cookies:
        <table>
          <tbody>
            <tr>
              <td>Description of Cookie</td>
              <td>Purpose</td>
            </tr>

            <tr>
              <td>Analytical Cookies</td>
              <td>
                We use analytical cookies anonymously to help us analyse how
                users use the website so that we can continually improve the
                service.
              </td>
            </tr>
          </tbody>
        </table>
        <br></br>
        <br></br>
        Last modified May 23 2019
      </Text>
    </Container>
  );
};

export default PrivacyPolicy;
